import { Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureToggleService } from './feature-toggle.service';

@Directive({
  selector: '[idealsFeatureToggle]',
})
export class FeatureToggleDirective implements OnInit {
  readonly idealsFeatureToggle = input.required<string>();
  readonly idealsFeatureToggleElse = input<TemplateRef<unknown>>();

  readonly #featureToggleService = inject(FeatureToggleService);
  readonly #tpl = inject<TemplateRef<unknown>>(TemplateRef);
  readonly #vcr = inject(ViewContainerRef);

  ngOnInit(): void {
    const isEnabled = this.#featureToggleService.isEnabled(this.idealsFeatureToggle());

    if (isEnabled) {
      this.#vcr.createEmbeddedView(this.#tpl);
    } else if (this.idealsFeatureToggleElse()) {
      this.#vcr.createEmbeddedView(this.idealsFeatureToggleElse());
    } else {
      this.#vcr.clear();
    }
  }
}
